import React from 'react';

import { useState, useRef, useContext } from 'react';

import { Button, Form, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import Select from 'react-select';

import useRequest from '../helper/useRequest';

import { toast } from 'react-toastify';
import Alert from '../helper/Alert';
import AppContext from '../AppContext';
import Separator from '../helper/Separator';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

import {
    email,
    emailRepeat,
    password,
    passwordRepeat,
    username,
    firstName,
    lastName,
    phoneNo,
    dataProtection,
    newsletterOptIn,
} from '../helper/Schema';


const schema = yup.object().shape({
    Email: email,
    Emailrepeat: emailRepeat,
    Password: password,
    Passwordrepeat: passwordRepeat,
    Username: username,
    FirstName: firstName,
    LastName: lastName,
    PhoneNo: phoneNo,
});

function User() {
    const { request } = useRequest();
    const { Salutations } = useContext(AppContext);

    const formRef = useRef(null);

    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const [finishMessage, setFinishMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleRegister = async (values) => {
        let pathname = location.pathname.split("/");
        let key = pathname[pathname.length-1];
        values.key = key;

        setLoading(true);
        const result = await request("/Register/RegisterUser", values);
        const json = result.data;

        setLoading(false);
        if (json.r == 1) {
            setFinishMessage(true);
        }
        else {
            setMessage(json.message);
        }
    }

    const salutationOptions = Salutations.map((a) => { return { value: a.SalutationID, label: a.Description }; });

    if (finishMessage != false) {
        return (
            <>
                <h2 className="mb-4">Registrierung erfolgreich</h2>
                <p>Vielen Dank für Ihre Registrierung. Ihre Daten wurden erfolgreich verarbeitet.</p>
                <p>Zur Bestätigung erhalten Sie noch eine E-Mail von uns.</p>
                <Button variant="primary" href="/?ReturnUrl">Zum Login</Button> 
            </>
        );
    }

    

    return (
        <Formik
            innerRef={(f) => formRef.current = f}
            validationSchema={schema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={(values) => {
                handleRegister(values);
            }}
            initialValues={{
                Email: '',
                Emailrepeat: '',
                Username: '',
                Password: '',
                Passwordrepeat: '',
                SalutationID: 1,
                Title: '',
                FirstName: '',
                LastName: '',
                PhoneNo: '',
                NewsletterOptIn: true
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => {
                return (
                    <Form noValidate onSubmit={handleSubmit} className="mt-3">
                        {message && <Alert type="error" message={message} />}
                        <Separator text="Benutzerdaten" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="EmailB">
                                    <Form.Label className="required" column sm={6}>E-Mail-Adresse</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Email && touched.Email} placeholder="" name="Email" value={values.Email} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Emailrepeat" autoComplete="off">
                                    <Form.Label className="required" column sm={6}>E-Mail wiederholen</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Emailrepeat && touched.Emailrepeat} placeholder="" name="Emailrepeat" value={values.Emailrepeat} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Emailrepeat}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="UsernameB">
                                    <Form.Label className="required" column sm={6}>Benutzername</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Username && touched.Username} placeholder="" name="Username" value={values.Username} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Username}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Password" autoComplete="off">
                                    <Form.Label className="required" column sm={6}>Passwort</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Password && touched.Password} type={passwordShown ? "text" : "password"} placeholder="" name="Password" value={values.Password} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Password}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Passwordrepeat" autoComplete="off">
                                    <Form.Label className="required" column sm={6}>Passwort wiederholen</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Passwordrepeat && touched.Passwordrepeat} type={passwordShown ? "text" : "password"} placeholder="" name="Passwordrepeat" value={values.Passwordrepeat} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Passwordrepeat}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Separator text="Kontaktdaten" />
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="SalutationID" name="SalutationID" onBlur={handleBlur} onChange={handleChange}>
                                    <Form.Label className="required" column sm={6}>Anrede</Form.Label>
                                    <Col sm={6}>
                                        <Select defaultValue={salutationOptions[0]} name="SalutationID" options={salutationOptions} classNamePrefix="bv-select" className="bv-select" placeholder="Bitte auswählen" onChange={
                                            (value) => {
                                                formRef.current.setFieldValue("SalutationID", value.value);
                                            }
                                        } />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="Title">
                                    <Form.Label column sm={6}>Titel</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.Title && touched.Title} placeholder="" name="Title" value={values.Title} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.Title}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="FirstName">
                                    <Form.Label className="required" column sm={6}>Vorname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.FirstName && touched.FirstName} placeholder="" name="FirstName" value={values.FirstName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.FirstName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="LastName">
                                    <Form.Label className="required" column sm={6}>Nachname</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.LastName && touched.LastName} placeholder="" name="LastName" value={values.LastName} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.LastName}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="mb-3" controlId="PhoneNo">
                                    <Form.Label column sm={6}>Telefonnummer</Form.Label>
                                    <Col sm={6}>
                                        <Form.Control isInvalid={errors.PhoneNo && touched.PhoneNo} placeholder="" name="PhoneNo" value={values.PhoneNo} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.PhoneNo}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>

                            </Col>
                        </Row>

                        <Row>
                            {/*<Col xs={12}>*/}
                            {/*    <Form.Group className="mb-3" controlId="NewsletterOptIn">*/}
                            {/*        <Form.Check type="checkbox" name="NewsletterOptIn" label="Ich möchte wöchentlich über Termine per Mail informiert werden." value={values.NewsletterOptIn} onChange={handleChange} isInvalid={errors.NewsletterOptIn} />*/}
                            {/*        <div className="text-danger">{errors.NewsletterOptIn && (errors.NewsletterOptIn)}</div>*/}
                            {/*    </Form.Group>*/}
                            {/*</Col>*/}
                        </Row>

                        <Row>
                            <Col xs={12}>
                                Bitte nehmen Sie auch unsere <a target="_blank" href="/datenschutz"><u>Datenschutzerklärung</u></a> zur Kenntnis.
                            </Col>
                            <Col xs={12} lg={6}>

                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={6}>
                                <MandatoryFieldNotice/>
                            </Col>
                            <Col xs={12} lg={6} className="text-right">
                                <Button variant="secondary" type="submit">
                                    <i className="fa-solid fa-right-to-bracket mr-2"></i>Registrieren
                                </Button>
                            </Col>
                        </Row>

                    </Form>
                )
            }}
        </Formik>
    );
}

export default User;